<template>
    <div v-if="badges.applied.length || badges.ignored.length" class="filter-badges" role="note">
        <StatusChip v-for="chip in badges.applied" :key="'a-' + chip.label" :label="chip.label" tone="info"
            icon="fas fa-filter"></StatusChip>
        <span v-for="chip in badges.ignored" :key="'i-' + chip.label" :title="chip.reason" class="filter-badges__ignored">
            <StatusChip :label="chip.label" tone="neutral" outlined icon="fas fa-circle-info"></StatusChip>
        </span>
    </div>
</template>
<script>
import StatusChip from '@/components/shared/StatusChip.vue';

/**
 * Chips de los filtros del tablero en un widget: los que se aplicaron (azul) y los que no, con el motivo en el
 * tooltip (gris, borde). Recibe `filterBadges` del mixin de filtros:
 *
 *   <FilterBadges :badges="filterBadges"></FilterBadges>
 */
export default {
    name: 'FilterBadges',
    components: { StatusChip },
    props: {
        badges: { type: Object, default: () => ({ applied: [], ignored: [] }) }
    }
};
</script>
<style scoped>
.filter-badges {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
}
.filter-badges__ignored {
    cursor: help;
}
</style>
